import { Tag, TagLabel, TagLeftIcon,Icon } from "@chakra-ui/react";
import React from "react";
import { useState } from "react";
import { AiOutlineCloseCircle ,AiOutlineArrowUp } from "react-icons/ai";
import { FcMenu  ,FcHome ,FcAbout, FcDownload ,FcPositiveDynamic,FcBusinessContact,FcGallery } from "react-icons/fc";
import pdf from '../Assests/Disha Gupta Resume.pdf'
import { resumeLink } from '../Compo/Resume/ResumeNew';
import { useRef } from "react";
import { useEffect } from "react";

const NavbarNew = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const header = useRef(null);
  const backTopBtn=useRef(null)

  const handleResume = () => {
    window.open(resumeLink);
  };
  useEffect(() => {
    const accordian_btn = document.querySelector(".accordian-btn")
    const handleScroll = () => {
      if (window.scrollY >= 100) {
        header.current.classList.add("active");
        backTopBtn.current.classList.add("active");
        accordian_btn.style.bottom='85px'
      } else {
        header.current.classList.remove("active");
        backTopBtn.current.classList.remove("active");
        accordian_btn.style.bottom='20px'
      }
    };
  
    window.addEventListener("scroll", handleScroll);
  
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const navdata = [
    {
      iconname: FcHome,
      text: "Home",
      linkname: "home",
    },
    {
      iconname: FcAbout,
      text: "About",
      linkname: "about",
    },
    {
        iconname: FcPositiveDynamic,
        text: "Skills",
        linkname: "skills",
      },
      {
        iconname: FcGallery,
        text: "Projects",
        linkname: "projects",
      },
      {
        iconname: FcBusinessContact,
        text: "Contact",
        linkname: "contact",
      },
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  return (
    <>      
   
    <header ref={header} className="header">
      <div className="container">
        <a href="#" className="logo"  >
          {/* <img src="./assets/images/logo.svg" width="119" height="37" alt="Wren logo"> */}
          Disha
        </a>

        <nav className={`navbar ${isMobileMenuOpen ? "active" : ""}`}>
          <div className="navbar-top">
            <a href="#" className="logo">
              {/* <img src="./assets/images/logo.svg" width="119" height="37" alt="Wren logo"> */}
            </a>

            <button className="nav-close-btn" aria-label="close menu">
              <AiOutlineCloseCircle onClick={toggleMobileMenu} />
            </button>
          </div>

          <ul className={`navbar-list ${isMobileMenuOpen ? "active" : ""}`}>

  {
    navdata.map((el,index)=>
    <li>
    <NavbarCard  {...el} toggleMobileMenu={toggleMobileMenu} />
  </li>
    )
  }
       
          </ul>
        </nav>
<button id="resume-button-1" className="btn btn-primary" onClick={handleResume}     >
<a  id="resume-link-1"
                  href={pdf}
                  download="Disha_Gupta_Resume"
                  target="_blank"
                
                  rel="noreferrer"  >
          Resume <Icon as={FcDownload}/>
        </a>
</button>
      
 
        <button
          className={`nav-open-btn ${isMobileMenuOpen ? "active" : ""}`}
          onClick={toggleMobileMenu}
        >
          <FcMenu />
        </button>
      </div>
    
    </header>  <a href="#top" ref={backTopBtn} className="back-top-btn" aria-label="back to top" >
    <AiOutlineArrowUp/>
    </a>
  </>
  );
};

export default NavbarNew;

export const NavbarCard = ({ iconname, text, toggleMobileMenu, linkname }) => {
  return (
    <Tag
    bg='0'
    fontSize={'16px'}
    >
      <TagLeftIcon as={iconname} />
      <TagLabel  as="a"
      href={`#${linkname}`}
      onClick={toggleMobileMenu}
    
      className="navbar-link hover-1" >{text}</TagLabel>
    </Tag>
  );
};
